export default "__VITE_ASSET__BjVHrf4S__"